module.exports = __webpack_public_path__ + "media/images/ponce_battery_horizontal-31e77a47.jpeg";